import { useEffect, useState } from 'react'
import { logoutLocalOnly } from '../../../auth/oidc'
import { setFlashToast } from '../../../auth/state'

export default function LogoutCallback() {
  const [done, setDone] = useState(false)
  useEffect(() => {
    logoutLocalOnly()
    setFlashToast({ kind: 'success', title: 'Signed out', message: 'Logout successful.' })
    setDone(true)
    const t = setTimeout(() => window.location.replace('/login?fresh=1&auto=0'), 50)
    return () => clearTimeout(t)
  }, [])

  return (
    <div className="chamii-viewport chamii-safe-top chamii-safe-bottom bg-dots chamii-auth-shell flex items-center justify-center p-6">
      <div className="w-full max-w-lg bg-brand-surface rounded-[3rem] p-3 shadow-2xl border-2 border-brand-textDark/10">
        <div className="bg-brand-yellow rounded-[2.5rem] px-10 py-12 text-center">
          <div className="w-24 h-24 bg-white rounded-full mx-auto flex items-center justify-center shadow-lg shadow-brand-yellow/20 border-4 border-brand-yellowDark">
            <div className="w-10 h-10 rounded-full border-4 border-brand-textDark/20 border-t-brand-pink animate-spin" />
          </div>
          <div className="mt-7 text-4xl font-black tracking-tight text-brand-textDark">{done ? 'Signed out' : 'Signing out…'}</div>
          <div className="mt-3 text-brand-text font-bold">{done ? 'Redirecting…' : 'Finishing logout…'}</div>

          <div className="mt-8 grid gap-3">
            <button
              type="button"
              className="w-full rounded-2xl bg-white/70 text-brand-textDark font-extrabold py-4 border-2 border-white hover:bg-white transition-colors"
              onClick={() => window.location.replace('/login?fresh=1&auto=0')}
            >
              Back to sign in
            </button>
          </div>

          <div className="mt-8 text-[11px] font-black text-brand-text tracking-widest uppercase">Logout</div>
        </div>
      </div>
    </div>
  )
}
